import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="oferta" className="py-24 px-4 bg-sage relative overflow-hidden" data-id="element-65">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-66">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} data-id="element-67"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-2xl text-center" data-id="element-69">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-brown" data-id="element-70">
            Recuperá tu bienestar hoy mismo
          </h2>

          <p className="text-xl text-brown/80 mb-10 max-w-2xl mx-auto" data-id="element-71">
            No esperes al lunes para dejar de sentirte mal. Llevate el Plan
            Pancita Desinflamada completo con todos los bonos incluidos.
          </p>

          <div className="bg-cream/50 rounded-3xl p-8 mb-10 border border-gold/20 relative" data-id="element-72">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-white px-6 py-1.5 rounded-full text-sm font-bold tracking-wider uppercase shadow-md" data-id="element-73">
              Precio Lanzamiento
            </div>

            <div className="flex items-baseline justify-center gap-2 mt-4" data-id="element-74">
              <span className="text-3xl font-bold text-brown/60" data-id="element-75">$</span>
              <span className="text-6xl md:text-7xl font-bold text-brown" data-id="element-76">
                9.300
              </span>
              <span className="text-xl font-bold text-brown/60" data-id="element-77">ARS</span>
            </div>
            <p className="text-sm text-brown/60 mt-2" data-id="element-78">
              Pago único. Acceso de por vida.
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto px-10 py-5 text-xl font-bold text-white bg-terracotta rounded-full shadow-lg hover:bg-terracotta/90 hover:shadow-xl transition-all duration-300 mb-6 relative overflow-hidden group" data-id="element-79">
            <span className="relative z-10" data-id="element-80">¡QUIERO MI PLAN AHORA!</span>
            <div className="absolute inset-0 h-full w-full bg-white/20 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500 ease-out" data-id="element-81" />
          </motion.button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-brown/70 font-medium" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-84" />
              <span data-id="element-85">Compra 100% segura</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-brown/30 rounded-full" data-id="element-86" />
            <div className="flex items-center gap-2" data-id="element-87">
              <CreditCardIcon className="w-5 h-5 text-sage" data-id="element-88" />
              <span data-id="element-89">Mediante Mercado Pago</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-brown/30 rounded-full" data-id="element-90" />
            <div className="flex items-center gap-2" data-id="element-91">
              <span className="text-sage font-bold" data-id="element-92">⚡</span>
              <span data-id="element-93">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}